import CROP_TYPES from './crop-types';

export default [
  {
    name: CROP_TYPES.ALFALFA,
    yield: {
      min: 2,
      max: 8,
      unit: 'ton/ac'
    },
    nutrients: [
      {
        name: 'Nitrogen',
        formula: 'n',
        min: 102,
        max: 408
      },
      {
        name: 'Phosphorus pentoxide',
        formula: 'p2o5',
        min: 24,
        max: 96
      },
      {
        name: 'Potassium oxide',
        formula: 'k2o',
        min: 98,
        max: 392
      },
      {
        name: 'Sulfur',
        formula: 's',
        min: 10.8,
        max: 43.2
      },
      {
        name: 'Magnesium',
        formula: 'mg',
        min: 10.4,
        max: 41.6
      }
    ]
  },
  {
    name: CROP_TYPES.CORN_GRAIN,
    yield: {
      min: 180,
      max: 300,
      unit: 'bu/ac'
    },
    nutrients: [
      {
        name: 'Nitrogen',
        formula: 'n',
        min: 120.6,
        max: 201
      },
      {
        name: 'Phosphorus pentoxide',
        formula: 'p2o5',
        min: 63,
        max: 105
      },
      {
        name: 'Potassium oxide',
        formula: 'k2o',
        min: 45,
        max: 75
      },
      {
        name: 'Sulfur',
        formula: 's',
        min: 14.4,
        max: 24
      },
      {
        name: 'Magnesium',
        formula: 'mg',
        min: 14.4,
        max: 24
      }
    ]
  },
  {
    name: CROP_TYPES.CORN_SILAGE,
    yield: {
      min: 10,
      max: 34,
      unit: 'ton/ac'
    },
    nutrients: [
      {
        name: 'Nitrogen',
        formula: 'n',
        min: 97,
        max: 329.8
      },
      {
        name: 'Phosphorus pentoxide',
        formula: 'p2o5',
        min: 31,
        max: 105.4
      },
      {
        name: 'Potassium oxide',
        formula: 'k2o',
        min: 73,
        max: 248.2
      },
      {
        name: 'Sulfur',
        formula: 's',
        min: 11,
        max: 37.4
      },
      {
        name: 'Magnesium',
        formula: 'mg',
        min: 23,
        max: 78.2
      }
    ]
  },
  {
    name: CROP_TYPES.SOYBEAN,
    yield: {
      min: 40,
      max: 100,
      unit: 'bu/ac'
    },
    nutrients: [
      {
        name: 'Nitrogen',
        formula: 'n',
        min: 130,
        max: 325
      },
      {
        name: 'Phosphorus pentoxide',
        formula: 'p2o5',
        min: 29.2,
        max: 73
      },
      {
        name: 'Potassium oxide',
        formula: 'k2o',
        min: 48,
        max: 120
      },
      {
        name: 'Sulfur',
        formula: 's',
        min: 7.2,
        max: 18
      },
      {
        name: 'Magnesium',
        formula: 'mg',
        min: 7.2,
        max: 18
      }
    ]
  },
  {
    name: CROP_TYPES.CANOLA,
    yield: {
      min: 30,
      max: 90,
      unit: 'bu/ac'
    },
    nutrients: [
      {
        name: 'Nitrogen',
        formula: 'n',
        min: 48,
        max: 144
      },
      {
        name: 'Phosphorus pentoxide',
        formula: 'p2o5',
        min: 24,
        max: 72
      },
      {
        name: 'Potassium oxide',
        formula: 'k2o',
        min: 12,
        max: 36
      },
      {
        name: 'Sulfur',
        formula: 's',
        min: 7.5,
        max: 22.5
      },
      {
        name: 'Magnesium',
        formula: 'mg',
        min: 9,
        max: 27
      }
    ]
  },
  {
    name: CROP_TYPES.COTTON,
    yield: {
      min: 1,
      max: 4,
      unit: 'bale/ac'
    },
    nutrients: [
      {
        name: 'Nitrogen',
        formula: 'n',
        min: 32,
        max: 128
      },
      {
        name: 'Phosphorus pentoxide',
        formula: 'p2o5',
        min: 14,
        max: 56
      },
      {
        name: 'Potassium oxide',
        formula: 'k2o',
        min: 19,
        max: 76
      },
      {
        name: 'Magnesium',
        formula: 'mg',
        min: 3.5,
        max: 14
      }
    ]
  },
  {
    name: CROP_TYPES.SPRING_WHEAT,
    yield: {
      min: 40,
      max: 100,
      unit: 'bu/ac'
    },
    nutrients: [
      {
        name: 'Nitrogen',
        formula: 'n',
        min: 59.6,
        max: 149
      },
      {
        name: 'Phosphorus pentoxide',
        formula: 'p2o5',
        min: 22.8,
        max: 57
      },
      {
        name: 'Potassium oxide',
        formula: 'k2o',
        min: 13.2,
        max: 33
      },
      {
        name: 'Sulfur',
        formula: 's',
        min: 4,
        max: 10
      },
      {
        name: 'Magnesium',
        formula: 'mg',
        min: 6,
        max: 15
      }
    ]
  },
  {
    name: CROP_TYPES.WINTER_WHEAT,
    yield: {
      min: 40,
      max: 100,
      unit: 'bu/ac'
    },
    nutrients: [
      {
        name: 'Nitrogen',
        formula: 'n',
        min: 46.4,
        max: 116
      },
      {
        name: 'Phosphorus pentoxide',
        formula: 'p2o5',
        min: 19.2,
        max: 48
      },
      {
        name: 'Potassium oxide',
        formula: 'k2o',
        min: 11.6,
        max: 29
      },
      {
        name: 'Sulfur',
        formula: 's',
        min: 4,
        max: 10
      },
      {
        name: 'Magnesium',
        formula: 'mg',
        min: 6,
        max: 15
      }
    ]
  }
];
